import { useState, useEffect } from "react";
import { KPIStatistic, Icon, Card } from "@scuf/common";
import { useDispatch } from "react-redux";
import KPIStatData from "./KPIStatData";
import KPIStatDataAPI from "./KPIStatDataAPI";
import baseServices from "../../../services/base.services";
import { startLineChart } from "../../../actions/entryDataChart";
// import TitlePage from '../../../components/TitlePage/TitlePage';

const KPIStat = ({ url, body, isCard, titleCard }) => {
  const dispatch = useDispatch();
  const [state, setState] = useState([]);

  // Metodo para esperar en milisegundos, usando funciones
  //const waitFor = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    const getData = async () => {
      try {
        if (body) {
          var response = await baseServices.getDataN2(body, url);
          if (response.data && response.data.length > 0) {
            //dispatch(startLineChart(response.data[0]))
            setState(KPIStatDataAPI(response));
            setTimeout(() => {
              getData()
          }, 150000);
          }
        } else {
          setState(KPIStatData());
          //dispatch(startLineChart('dummy data'))

          setTimeout(() => {
            getData()
        }, 150000);
        }
      } catch (err) {
        setTimeout(() => {
          getData()
      }, 150000);
      }
    };

    getData();
  }, []);

  return (
    <>
      {isCard === "1" ? (
        <Card>
          <Card.Header title={titleCard} className="m-0 p-0"></Card.Header>
          <Card.Content style={{ minHeight: "100px" }} className="m-0 p-0">
            {state &&
              state.map((y, i) => (
                <KPIStatistic
                  key={i}
                  title={y.Title}
                  value={<span style={{ fontSize: "45px" }}>{y.Value}</span>}
                  icon={
                    <Icon
                      name={y.IconName}
                      root={y.IconRoot}
                      color={y.IconColor}
                    />
                  }
                  imageUrl={y.ImageUrl}
                />
              ))}
          </Card.Content>
        </Card>
      ) : (
        state &&
        state.map((y, i) => (
          <KPIStatistic
            key={i}
            title={y.Title}
            value={y.Value}
            targetValue={y.TargetValue}
            icon={
              <Icon name={y.IconName} root={y.IconRoot} color={y.IconColor} />
            }
            imageUrl={y.ImageUrl}
          />
        ))
      )}
    </>
  );
};

export default KPIStat;
